import { useEffect, useRef } from "react";
import api from "@/lib/api";

/**
 * AdSlot renders a Google AdSense ad unit AND tracks local impression/click stats.
 */
export default function AdSlot({ snippet, publisherId, slotId, label = "Iklan", className = "", slotKey }) {
  const ref = useRef(null);
  const initialized = useRef(false);
  const impressionSent = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    if (!snippet && !slotId) return;
    initialized.current = true;
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch (e) {}
  }, [snippet, slotId]);

  useEffect(() => {
    if (!slotKey) return;
    if (impressionSent.current) return;
    if (!snippet && !(publisherId && slotId)) return;
    impressionSent.current = true;
    api.post("/ad-events", { slot: slotKey, event_type: "impression" }).catch(() => {});
  }, [slotKey, snippet, publisherId, slotId]);

  const handleClick = () => {
    if (!slotKey) return;
    api.post("/ad-events", { slot: slotKey, event_type: "click" }).catch(() => {});
  };

  if (!snippet && !(publisherId && slotId)) return null;

  return (
    <div className={`ad-slot w-full flex flex-col items-center ${className}`} data-testid="ad-slot" onClick={handleClick}>
      <div className="text-[10px] uppercase tracking-widest text-gray-600 mb-2">{label}</div>
      <div
        ref={ref}
        className="w-full max-w-4xl min-h-[90px] border border-white/5 bg-white/[0.02] flex items-center justify-center overflow-hidden"
      >
        {snippet ? (
          <div className="w-full flex justify-center" dangerouslySetInnerHTML={{ __html: snippet }} />
        ) : (
          <ins
            className="adsbygoogle"
            style={{ display: "block", width: "100%" }}
            data-ad-client={publisherId}
            data-ad-slot={slotId}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        )}
      </div>
    </div>
  );
}
